import React from "react";
import ProjectsHero from "./sections/ProjectsHero/ProjectsHero";
import ProjectsContent from "./sections/ProjectsContent/ProjectsContent";

const Projects = () => {
  return (
    <div>
      <ProjectsHero />
      <ProjectsContent />
    </div>
  );
};

export default Projects;
